export default {
  postureReport: "姿勢報告",
  postureData: "姿勢データ",
  postureDataContrast: "姿勢データの比較",
  postureRiskContrast: "姿勢リスクの比較",
  postureDataTrend: "姿勢データの傾向",
  postureRiskTrend: "姿勢リスクの傾向",
  postureLogData: "姿勢ログデータ",
  lateralhead: "横向きの頭部傾斜",
  unevenshoulder: "肩の不平",
  scoliosis: "脊柱側弯",
  unevenhip: "骨盤の横傾き",
  xleg: "X 脚",
  oleg: "O 脚",
  roundedshoulder: "丸い肩",
  kneehyperextension: "膝の過伸展",
  trunkforwardtilt: "Trunk forward tilt",
  trunklateraltilt: "Trunk Lateral Tilt",
  forwardhead: "頭部前傾",
  toTheLeft: "（左）",
  toTheRight: "（右）",
  bracketsLeft: "（L）",
  bracketsRight: "（R）",
  bracketsNormal: "（正常）",
  leg: "脚",
  legLeft: "脚（L）",
  legRight: "脚（R）",
  riskAssessment: "リスク評価",
  muscleState: "筋肉の状態",
  muscleStateDesc: "異常な筋肉の状態は見つかりません",
  testTime: "テスト時間",
  hRisk: "H",
  mRisk: "M",
  lRisk: "L",
  item: "項目",
  degree: "°",
  percent: "％",
  mm: "mm",
  moireImage: "モアレ画像",
  lAbnormalRisk: "L リスク",
  mAbnormalRisk: "M リスク",
  hAbnormalRisk: "H リスク",
  highRisk: "高リスク",
  riskAnalysis: "リスク分析",
  conclusionRecommendation: "結論と建議",
  solution: "解決策",
  movePosition: "ポイントをクリックして位置を移動します",
  confirmTheClose: "まだ保存されていません、閉じることを確認しますか？",
  closeInfo: "まだ保存されていません、閉じることを確認しますか？",
  share: "共有",
  front: "前面",
  side: "側面",
  back: "後面",
  otherSide: "もう一方の側面",
  points: "点",
  angle: "角度",
  name: "名称",
  gender: "性別",
  male: "男性",
  female: "女性",
  age: "年齢",
  year: "歳",
  height: "身長",
  weight: "体重",
  time: "時間",
  patientId: "患者ID",
  save: "保存",
  saveModify: "修正を保存",
  print: "印刷",
  cancel: "キャンセル",
  zoomIn: "拡大",
  zoomOut: "縮小",
  ok: "はい",
  return: "戻る",
  empty: "",
  unknown: "未知",
  succeedToCopy: "コピー成功",
  succeedToSave: "保存成功",
  headForwardDistance: "頭部前方距離",
  pelvisForwardTilt: "骨盤前傾角",
  wristHipDistanceLeft: "手首から股関節までの距離（左）",
  wristHipDistanceRight: "手首から股関節までの距離（右）",
  evaluator: "評価者",
  reportDate: "報告日",
  introduction: "紹",
  doctorIntroDefault: "専分野：リハビリテーション医学、姿勢評価と矯 |験数：5年以上 |専知識：スポーツ外傷リハビリテーション、姿勢矯、疼痛管理",
  recoveryLog: "回復ログ",
  returnToReport: "レポートに戻る",
  loading: "読み込み中...",
  showToolbox: "ツールボックスを表示",
  hideToolbox: "ツールボックスを隠す",
};

